import { Button, Dialog, DialogActions, DialogContent } from "@mui/material"
import { FC, useEffect, useState } from "react"
import { Formater, TypeRecords } from "src/framework/commons/Formater";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import { TrocarDistribuidor } from "src/providers/cadastros/TrocaDistribuidor"
import { SolicitacoesTrocaDistribuidor } from "src/providers/cadastros/TrocaDistribuidor/types"
import theme from "src/theme/light";


const text = theme.palette.grey;
interface Modal {
    openDialogSolicitacao: boolean;
    handleClose: () => void;
}

const solicitacoes = new TrocarDistribuidor()

const ModalSolicitacoes: FC<Modal> = ({openDialogSolicitacao, handleClose}) => {
    const [solicitacoesResponse, setSolicitacoesResponse] = useState<SolicitacoesTrocaDistribuidor[]>([]);
    const userInfo = LocalStorage.get("solar.userExtraInfo", true)

    useEffect(() => {
        if (userInfo?.revenda_cnpj_cpf) {
            solicitacoes.getSolicitacoes(userInfo.revenda_cnpj_cpf).then(response => {
                setSolicitacoesResponse(response);
            })
        }
    }, [userInfo?.revenda_cnpj_cpf])

    return (
        <Dialog
        className={"modal-edit-string"}
        open={openDialogSolicitacao}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        >
            <div style={{ minWidth: "470px", paddingLeft: "16px",  borderBottom: `1px solid ${text[400]}` }}>
                <span>
                    <h2>Histórico</h2>
                </span>
            </div>
            <DialogContent style={{ height: "550px"}}>
                { solicitacoesResponse?.length > 0 && solicitacoesResponse.map((solicitacao) => {
                    return (
                        <div className="X12 M12" style={{ width: "400px", marginTop: "10px", borderBottom: `1px solid ${text[400]}` }}>
                            
                                <div className="X12 M12"  style={{ textAlign: "center"}}>
                                    <strong><span>{Formater.toString(solicitacao.created_at, TypeRecords.DATE_TIME)}</span></strong>
                                </div>  
                                <span className="row X12 M12"><strong style={{ paddingRight: "5px"}}> Solicitante: </strong> {solicitacao.solicitante}</span>                                    
                                <span className="row X12 M12"><strong style={{ paddingRight: "5px"}}> CNPJ antigo: </strong> {solicitacao.cnpj_distribuidor_atual}</span>
                                <span className="row X12 M12"><strong style={{ paddingRight: "5px"}}> CNPJ novo: </strong> {solicitacao.cnpj_distribuidor_novo}</span>
                                <span className="row X12 M12"><strong style={{ paddingRight: "5px"}}> Justificativa: </strong> {solicitacao.justificativa}</span>
                                <div style={{ width: "400px", marginBottom: "15px"}}>
                                    { solicitacao.situacao === "pendente" && (
                                        <span className="row X12 M12"><strong style={{ paddingRight: "5px"}}>Status:</strong> 
                                            <div style={{ width: "95px", backgroundColor: "#CC8F00", borderRadius: "15px", textAlign: "center" }}>
                                                Em análise
                                            </div>
                                        </span>
                                    )}
                                    { solicitacao.situacao === "reprovada" && (
                                        <span className="row X12 M12"><strong style={{ paddingRight: "5px"}}>Status:</strong> 
                                            <div style={{ width: "95px", backgroundColor: "#CC1414", borderRadius: "15px", textAlign: "center" }}>
                                                Reprovada
                                            </div>
                                        </span>
                                    )}
                                    { solicitacao.situacao === "aprovada" && (
                                        <span className="row X12 M12"><strong style={{ paddingRight: "5px"}}>Status:</strong> 
                                            <div style={{ width: "95px", backgroundColor: "#00AF39", borderRadius: "15px", textAlign: "center" }}>
                                                Aprovada
                                            </div>
                                        </span>
                                    )}
                                </div>
                        </div>
                    )
                })}
            </DialogContent>    
            <DialogActions>
                <Button 
                    onClick={handleClose} 
                    variant="contained"
                    color="primary">
                    FECHAR
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export { ModalSolicitacoes }